import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { createOrder } from '../orders'

export default function useOrderCreate() {
  const queryClient = useQueryClient()

  const { mutateAsync, data, reset, isLoading } = useMutation(createOrder, {
    onSuccess: () => {
      queryClient.invalidateQueries('opportunities')
      notification.success({
        message: 'Sucesso!',
        description: 'Cadastro realizado com sucesso!'
      })
    },
    onError: () => {
      notification.error({
        message: 'Erro',
        description: 'Não foi possível completar o cadastro!'
      })
    }
  })

  return { mutateAsync, data, reset, isLoading }
}
